var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 36,
    viewBox: "0 0 24 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9551 17.8232C23.9845 17.8739 24 17.9314 24 17.99C24 18.0486 23.9845 18.1061 23.9551 18.1568L18.0429 27.1346L12.2716 35.8688C12.2403 35.9096 12.2 35.9426 12.1538 35.9654C12.1075 35.9882 12.0566 36 12.005 36C11.9534 36 11.9025 35.9882 11.8563 35.9654C11.8101 35.9426 11.7697 35.9096 11.7384 35.8688L5.96713 27.1346L0.044927 18.1735C0.0154943 18.1228 0 18.0652 0 18.0067C0 17.9481 0.0154943 17.8906 0.044927 17.8399L5.96713 8.86211L11.7384 0.131243C11.7697 0.0904392 11.8101 0.0573689 11.8563 0.0346056C11.9025 0.0118424 11.9534 0 12.005 0C12.0566 0 12.1075 0.0118424 12.1538 0.0346056C12.2 0.0573689 12.2403 0.0904392 12.2716 0.131243L18.0429 8.86211L23.9551 17.8232Z",
    fill: "url(#paint0_linear_1_663)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_663",
    x1: 0,
    y1: 0,
    x2: 23.8799,
    y2: 0.106669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA50E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.319615,
    stopColor: "#E561E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598086,
    stopColor: "#F183BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.786045,
    stopColor: "#F479BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F37CC3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDia);
export default __webpack_public_path__ + "static/media/dia.ffc8e0d3e0a774c084fd7542c1fecc73.svg";
export { ForwardRef as ReactComponent };